import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';
import logoImage from '../assets/logo.png';
import { Sun, Moon, ArrowUpRight } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Layout = () => {
  const location = useLocation();
  const { isDark, toggleTheme } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={`${isDark ? 'bg-[#0E1314]' : 'bg-[#F7FAF8]'} text-white min-h-screen`}>
      {/* Header */}
      <header className={`sticky top-0 z-50 h-[72px] w-full border-b backdrop-blur-md ${
        isDark
          ? 'bg-[#0a0f0e]/80 border-[#1f3a2a]'
          : 'bg-[#F7FAF8]/90 border-[#dceee3]'
      }`}>
        <div className="max-w-[1280px] mx-auto px-4 h-full flex items-center justify-between">
          {/* Logo */}
          <img
            src={logoImage}
            alt="Vuzo Logo"
            className="cursor-pointer max-h-[52px]"
            onClick={() => window.location.href = '/'}
          />

          {/* Right side: CTA + toggle */}
          <div className="flex items-center gap-3">
            {/* Open App CTA */}
            <a
              href="https://chat.vuzo.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-[10px] text-[14px] font-semibold transition-all duration-200 ${
                isDark
                  ? 'bg-[#28F5AB15] border border-[#28F5AB50] text-[#28F5AB] hover:bg-[#28F5AB25]'
                  : 'bg-[#177755] text-white hover:bg-[#0f5b3e] shadow-sm'
              }`}
            >
              Open App
              <ArrowUpRight className="w-4 h-4" />
            </a>

            {/* Theme toggle */}
            <button
              onClick={toggleTheme}
              aria-label="Toggle theme"
              className={`relative flex items-center w-[52px] h-[28px] rounded-full border transition-colors duration-300 ${
                isDark
                  ? 'bg-[#0D2E23] border-[#28F5AB40]'
                  : 'bg-[#E8F8EF] border-[#17775530]'
              }`}
            >
              <span className={`absolute w-[22px] h-[22px] rounded-full flex items-center justify-center shadow-sm transition-all duration-300 ${
                isDark
                  ? 'translate-x-[26px] bg-[#28F5AB]'
                  : 'translate-x-[3px] bg-[#177755]'
              }`}>
                {isDark
                  ? <Moon className="w-3 h-3 text-[#0A0A0A]" />
                  : <Sun className="w-3 h-3 text-white" />
                }
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        <Outlet />
      </main>

      {/* Footer — dark green gradient in both modes */}
      <div className="w-full" style={{ background: 'linear-gradient(180deg, #0D2018 0%, #091410 100%)' }}>
        <div className="max-w-[1280px] mx-auto px-4 md:px-12 2xl:px-4">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
